import { Checkbox, FormControlLabel, MenuItem } from "@mui/material";

import { SyntheticEvent } from "react";

const CheckboxMenuItem = (props: {
  value: string;
  label: string;
  selectedValues?: string[];
  disabled?: boolean;
  onChange: (event: SyntheticEvent, checked: boolean) => void;
}) => {
  const { value, label, selectedValues, disabled, onChange } = props;
  return (
    <MenuItem sx={{ paddingY: 0 }}>
      <FormControlLabel
        value={value}
        control={<Checkbox checked={selectedValues?.includes(value)} />}
        label={label}
        disabled={disabled}
        onChange={onChange}
      />
    </MenuItem>
  );
};

export default CheckboxMenuItem;
